export default __webpack_public_path__ + "static/media/hydra-guard-whiteTheme.01ebb3ea.png";